<template src="./buttonPrint.pug" lang="pug"></template>

<script>
import printHtmlElement from 'print-html-element'
import ButtonPrimary from '../buttonPrimary/ButtonPrimary'

export default {
  name: 'ButtonPrint',

  components: {
    ButtonPrimary
  },

  methods: {
    print () {
      let clonedElement = document.createElement('toPrint')

      let printableArray = Array.from(document.getElementsByClassName('printable'))

      printableArray.forEach(function (element) {
        clonedElement.appendChild(element.cloneNode(true))
      }, this)

      // - Remove paginação da impressão (informação mostrando 1 a 10 de N registros)
      this.removeObjectByClass(clonedElement, 'dataTables_info')

      // - Remove paginação da impressão (páginas)
      this.removeObjectByClass(clonedElement, 'dataTables_paginate')

      // - Remove campo busca da impressão
      this.removeObjectByTag(clonedElement, 'input')

      // - Tabelas
      // - Lógica para inserir todos os elementos da tabela sem a paginação.
      this.showAllTableObjects(clonedElement)

      // - Text area
      let textAreaArray = Array.from(clonedElement.getElementsByTagName('textarea'))
      this.getValueElement(textAreaArray)

      // - Multiselect
      this.getValueComponentMultiselect(clonedElement)

      this.getElementsTd(clonedElement)
      printHtmlElement.printElement(clonedElement, {
        styles: []
      })

      return true
    },

    removeObjectByClass (clonedElement, className) {
      let elementArray = Array.from(clonedElement.getElementsByClassName(className))
      elementArray.forEach(function (element) {
        element.style.display = 'none'
      }, this)
    },

    removeObjectByTag (clonedElement, tagName) {
      let elementArray = Array.from(clonedElement.getElementsByTagName(tagName))
      elementArray.forEach(function (element) {
        element.style.display = 'none'
      }, this)
    },

    showAllTableObjects (clonedElement) {
      let tableArray = Array.from(clonedElement.getElementsByTagName('table'))

      tableArray.forEach(function (element) {
        var idTable = $(element).attr('id')
        var htmlTd = ''
        var htmlTrInicio = '<tr role="row" class="odd">'
        var htmlTrFim = '</tr>'

        $('#' + idTable).DataTable().rows().iterator('row', function (context, index) {
          var node = $(this.row(index).node())
          htmlTd = htmlTd + (htmlTrInicio + node.context.innerHTML + htmlTrFim)
        })

        element.getElementsByTagName('tbody')[0].innerHTML = htmlTd
      }, this)
    },

    getValueComponentMultiselect (clonedElement) {
      let multiselectArray = Array.from(clonedElement.getElementsByClassName('multiselect'))

      multiselectArray.forEach(function (element) {
        let elementArray = Array.from(element.getElementsByTagName('input'))

        elementArray.forEach(function (elementAux) {
          if (elementAux.value) {
            element.innerHTML = elementAux.value
          }
        }, this)
      }, this)
    },

    getElementsTd (clonedElement) {
      let tdArray = Array.from(clonedElement.getElementsByTagName('td'))
      tdArray.forEach(function (element) {
        if (element.title) {
          element.innerHTML = element.title
        }
      }, this)
    },

    getValueElement (elementArray) {
      elementArray.forEach(function (element) {
        if (element.value) {
          element.innerHTML = element.value
        }
      }, this)
    }
  }
}
</script>

<style lang="css">
#btnImprimirTabela {
  margin-top: 15px !important
}
</style>



// WEBPACK FOOTER //
// ButtonPrint.vue?5b91c438